import { css } from '@emotion/react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { useIntl } from 'react-intl';

import { useSDK } from '../../../app';
import { commonMessages } from '../../../i18n/commonMessages';
import { styled } from '../../../styled';
import type { Theme } from '../../../theme/interface/detailed';
import { useShouldDisplayOperatorInfo } from '../../../utils/useShouldDisplayOperatorInfo';
import { AgentInfo } from './agentInfo';
import { AgentAvatarWrapper } from './agentInfo/agentAvatarWrapper';
import { AgentName } from './agentInfo/agentName';
import { AgentRole } from './agentInfo/agentRole';
import { AgentTextWrapper } from './agentInfo/agentTextWrapper';

type Interface = { className: string };

const options = ['HEADER', 'HEADER_AND_DIALOG', 'HEADER_AND_DIALOG_OVERRIDES_STATIC_HEADER'];

//todo tooltip refactor
const styles = css`
	position: relative;

	& svg {
		cursor: pointer;
	}

	&.chat-title {
		align-items: center;
		display: flex;
		justify-content: center;
		position: absolute;
		height: 100%;
		top: 0;
		left: 40%;
		width: 20%;
	}
`;

const Component = observer(({ className }: Interface): ReactElement => {
	const { conversationsStore, accountsStore } = useSDK();
	const shouldDisplayAgentInfo = useShouldDisplayOperatorInfo(options);
	const agentInfo = accountsStore.currentOperatorId && accountsStore.getAccountInfo(accountsStore.currentOperatorId);
	const { formatMessage } = useIntl();
	return shouldDisplayAgentInfo && agentInfo && !conversationsStore.isLatestConversationResolved ? (
		<AgentInfo>
			<AgentAvatarWrapper accountId={agentInfo.accountId} />
			<AgentTextWrapper>
				<AgentName>{agentInfo.showName || ''}</AgentName>
				<AgentRole>
					{agentInfo.role === 'OPERATOR'
						? formatMessage(commonMessages.operator)
						: agentInfo.displayName || ''}
				</AgentRole>
			</AgentTextWrapper>
		</AgentInfo>
	) : (
		<div className={className + ' chat-title'}>{formatMessage(commonMessages.chat)}</div>
	);
});

const ChatHeader = styled(Component)(
	({
		theme: {
			chat: {
				header: { chatHeader },
			},
		},
	}: {
		theme: Theme;
	}) => chatHeader,
	styles
);

export { ChatHeader };
